/* eslint-disable consistent-return */
/* eslint-disable react/prop-types */
import * as dayjs from 'dayjs'
import 'dayjs/locale/id'
import {
  List, ListItem, ListItemText, makeStyles,
} from '@material-ui/core'
import React, { useEffect, Fragment } from 'react'
import useAxios from '@hooks/useAxios'
import { resellerApiWithToken } from '@api/baseApi'
import LoadingApi from '@components/LoadingApi'
import ErrorMessage from '@components/ErrorMessage'
import Cookies from 'js-cookie'

const useStyles = makeStyles((theme) => ({
  withdraw: {
    padding: theme.spacing(3),
  },
  title: {
    fontSize: 20,
    fontWeight: 'bold',
  },
  btnBack: {
    marginBottom: theme.spacing(2),
  },
  primary: {
    fontSize: 14,
    color: '#777777',
  },
  secondary: {
    fontSize: 18,
    color: '#000000',
  },
  list: {
    display: 'flex',
  },
  ListItem: {
    flex: 1,
  },
}))

const WithdrawRequestDetail = ({ showId }) => {
  let withdrawPath
  const scope = Cookies.get('scope')

  if (scope === 'reseller') {
    withdrawPath = '/resellers/withdraws'
  } else {
    withdrawPath = '/affiliates/withdraws'
  }
  const classes = useStyles()
  const id = showId
  const getWithdraw = useAxios(resellerApiWithToken, 'get', `${withdrawPath}/${id}`)

  useEffect(() => {
    if (id) {
      getWithdraw.fetch()
    }
  }, [id])

  return (
    <div className={classes.withdraw}>
      {getWithdraw.isFetching && <LoadingApi loading={getWithdraw.isFetching} size={24} />}
      {getWithdraw.error && <ErrorMessage message="Terjadi kesalahan pada sistem" />}
      {
          getWithdraw.data
          && (
            <Fragment>
              <List className={classes.list}>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Nomor WD"
                    secondary={getWithdraw.data?.number}
                  />
                </ListItem>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Tanggal Dibuat"
                    secondary={getWithdraw.data?.created_at ? dayjs(getWithdraw.data?.created_at).locale('id').format('DD MMMM YYYY') : '-'}
                  />
                </ListItem>
              </List>
              <List className={classes.list}>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Nama Bank"
                    secondary={getWithdraw.data?.bank_name || getWithdraw.data?.bank_account?.bank_name}
                  />
                </ListItem>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Nama Pemilik"
                    secondary={getWithdraw.data?.account_name || getWithdraw.data?.bank_account?.name}
                  />
                </ListItem>
              </List>
              <List className={classes.list}>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Nomor Rekening"
                    secondary={getWithdraw.data?.bank_account_number || getWithdraw.data?.bank_account?.number}
                  />
                </ListItem>
                <ListItem className={classes.ListItem} style={{ textTransform: 'capitalize' }}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Status"
                    secondary={getWithdraw.data?.status}
                  />
                </ListItem>
              </List>
              <List className={classes.list}>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Biaya Admin"
                    secondary={getWithdraw.data?.formatted_admin_fee}
                  />
                </ListItem>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Amount"
                    secondary={getWithdraw.data?.formatted_amount}
                  />
                </ListItem>
              </List>
              <List className={classes.list}>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Tanggal Transfer"
                    secondary={getWithdraw.data?.transfered_at ? dayjs(getWithdraw.data?.transfered_at).locale('id').format('DD MMMM YYYY') : '-'}
                  />
                </ListItem>
                <ListItem className={classes.ListItem}>
                  <ListItemText
                    primaryTypographyProps={{ className: classes.primary }}
                    secondaryTypographyProps={{ className: classes.secondary }}
                    primary="Tanggal Approve"
                    secondary={getWithdraw.data?.approved_at ? dayjs(getWithdraw.data?.approved_at).locale('id').format('DD MMMM YYYY') : '-'}
                  />
                </ListItem>
              </List>
            </Fragment>
          )
        }
    </div>
  )
}

export default WithdrawRequestDetail
